import { useContext } from "react";
import { AuthContext } from "../contexts/auth";

const useAuth = () => {
  const context = useContext(AuthContext);

  /**
   * @function getUser
   * @description Obtém o usuário do localStorage
   * @returns {Object} - O usuário
   * @since 27/08/2025 - v2.7.27
   */
  const getUser = () => {
    try {
      const user = localStorage.getItem("user_token");
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error("Erro ao obter o usuário:", error);
      return null;
    }
  };

  return { ...context, getUser };
};

export default useAuth;